import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { baseParams } from '@/business/apiTreatment/request/queryParamsUtils';
import { formatInputDateTimeToGMTDate } from '@/business/utils/dates';
import ActionPlansService from '@/services/services/actionplans.service';
import CrudModule from '@/store/crudModule';

/**
 * Business function. make query newItem function for API call.
 * @returns {{group_id: *}} The makeQueryParams function.
 */
const makeCreateParams = ({ rootGetters, item }) => {
  const newItem = baseParams({ rootGetters, item });
  newItem.action_plan_status = 1;
  newItem.action_plan_origins = item.action_plan_origins.map((origin) => {
    return {
      ...origin,
      datetime: formatInputDateTimeToGMTDate(origin.datetime),
    };
  });
  return newItem;
};
/**
 * Business function. make query newItem function for API call.
 * @returns {{newItem: {group_id: *}}} The makeQueryParams function.
 */
const makeUpdateParams = ({ item, rootGetters }) => {
  const newItem = baseParams({ rootGetters, item });

  newItem.action_plan_origins = item.action_plan_origins.map((origin) => {
    return {
      ...origin,
      datetime: formatInputDateTimeToGMTDate(origin.datetime),
    };
  });
  return { newItem };
};

const setStatuWhenUserExchangeCreated = ({ commit, getters }) => {
  if (getters.current.action_plan_status === 1) {
    commit('UPDATE_CURRENT', {
      ...getters.current,
      action_plan_status: 2,
      current_act_status_type_name: 'En cours',
    });
  }
};

const attributesObj = {
  action_plan_status: {
    autocomplete: true,
    serverSide: true,
    values: [1, 2],
  },
};

export default new CrudModule({
  attributesObj,
  sortChoices: ['creation_datetime'],
  searchAttributesArray: [
    'description',
    'author_name',
    'property_search_code_list',
    'property_search_name_list',
    'property_search_shortname_list',
  ],
  hasDefaultFilters: true,
  serviceAPI: ActionPlansService,
  makeQueryParams: makeListRequest({
    useEntities: true,
  }),
  makeCreateParams,
  makeUpdateParams,
  customActions: { setStatuWhenUserExchangeCreated },
});
